import React from "react";
import { Table, Form } from "react-bootstrap";
import { BsCheck2Circle } from "react-icons/bs";

export default function PendingStatsTable(props) {
  const { tableStyle, tableData, statusSubmit, handleChange } = props;

  return (
    <>
      <Table borderless responsive className="bg-light">
        <thead style={tableStyle}>
          <tr className="equalWidth">
            <th>Order ID</th>
            <th>User ID</th>
            <th>Address</th>
            <th>Mobile</th>
            <th>Product ID</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Order Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(tableData) && tableData.map((d, i) => {
            return (
              <tr key={i} style={{ fontSize: ".9em" }} className="equalWidth">
                <td>{d?.order_id}</td>
                <td>{d?.user_id}</td>
                <td>
                  {d?.user_name},<br />
                  {d?.address},<br />
                  {d?.state},<br />
                  {d?.pincode}.
                </td>
                <td>{d?.mobile_no}</td>
                <td>{d?.product_id}</td>
                <td>{d?.product_name}</td>
                <td>{d?.quantity}</td>
                <td>{d?.order_date}</td>
                <td className="pendingWidth">
                  <div className="d-flex justify-content-center align-items-center">
                    <Form.Select
                      size="sm"
                      onChange={(e) => handleChange(e)}
                      style={{ fontSize: ".9em" }}>
                      <option value="pending">Pending</option>
                      <option value="confirm">Confirm</option>
                      <option value="cancel">Cancel</option>
                    </Form.Select>
                    &nbsp;
                    <button
                      onClick={() =>
                        statusSubmit(
                          d.order_id,
                          d.user_id,
                          d.product_id,
                          d.quantity
                        )
                      }
                      className="btn btn-sm btn-outline-success ms-1 m-0 pt-0"
                      style={{ fontSize: "1em", marginTop: "-5px" }}>
                      <BsCheck2Circle />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
